import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { NAV_LINKS, WHATSAPP_NUMBER } from './headerModel';

export const useHeaderViewModel = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const isActivePath = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return {
    isMenuOpen,
    setIsMenuOpen,
    isScrolled,
    navLinks: NAV_LINKS,
    whatsapp: WHATSAPP_NUMBER,
    isActivePath,
  };
};
